import React, { useCallback, useEffect, useState } from 'react';
import useDsInquiry from '../hook/useDsInquiry';
import useQuery from '../../../util/useQuery';
import { Form, Select, Table } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export const PERSONAL_TYPE = {
    PersonalData: 'Personal Data',
    SensitiveData: 'Sensitive Data',
};

export default function Tab3({ setDepartmentId }) {
    const { t, i18n } = useTranslation();

    const { hash } = useLocation();
    const params = useQuery();
    const [form] = Form.useForm();
    const [allValues, setAllValues] = useState({
        status: 'all',
        department: 'all',
    });
    const navigate = useNavigate();

    const [pagevalue, setPagevalue] = useState({
        p: 1,
        ps: 10,
        s: '',
        sd: '',
        total: 0,
    });

    const {
        department,
        dataflowRopa,
        loadingDetail,
        dataSubject,
        getDataFlowRopa,
        getCategoryPersonalData,
    } = useDsInquiry(setPagevalue);

    useEffect(() => {
        getCategoryPersonalData();
    }, [getCategoryPersonalData]);

    const getAllIdsFormCategory = useCallback(
        (id) => {
            let payload = {
                personalDataIds: '',
                sensitiveDataIds: '',
                topicDataIds: '',
            };
            const find = dataSubject.find((item) =>
                item.categoryPersonalDataIds.includes(id)
            );
            if (find) {
                const ids = find?.categoryPersonalDataIds.join(',');
                if (
                    find?.categoryPersonalDataType ===
                    PERSONAL_TYPE.PersonalData
                ) {
                    payload.personalDataIds = ids;
                    payload.sensitiveDataIds = '';
                    payload.topicDataIds = '';
                } else if (
                    find?.categoryPersonalDataType ===
                    PERSONAL_TYPE.SensitiveData
                ) {
                    payload.personalDataIds = '';
                    payload.sensitiveDataIds = ids;
                    payload.topicDataIds = '';
                } else {
                    payload.personalDataIds = '';
                    payload.sensitiveDataIds = '';
                    payload.topicDataIds = ids;
                }
            }
            return payload;
        },
        [dataSubject]
    );

    useEffect(() => {
        const id = params.get('id');
        const payload = {
            departmentId: '',
            ...getAllIdsFormCategory(id),
            ...pagevalue,
        };
        delete payload.total;
        if (hash === '#personal') {
            getDataFlowRopa(payload);
            navigate({
                search: `?id=${params.get('id')}`,
                hash: hash,
            });
        }
        resetAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDataFlowRopa, hash, params.get('id')]);

    const resetAll = () => {
        form.resetFields();
        setAllValues({
            department: 'all',
        });
        form.setFieldValue({
            department: 'all',
        });
        setDepartmentId('');
    };

    useEffect(() => {
        resetAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash]);

    const onValuesChange = (_, allValues) => {
        const id = params.get('id');
        const ids = getAllIdsFormCategory(id);
        const payload = {
            ...ids,
            departmentId:
                allValues.department === 'all' ? '' : allValues.department,
            ...pagevalue,
        };
        delete payload.total;
        setAllValues(allValues);
        getDataFlowRopa(payload);
        setDepartmentId(allValues.department);
    };

    const columns_dataflow = [
        {
            title: 'Data Flow',
            dataIndex: 'businessFullName',
            key: 'businessFullName',
            width: '40%',
        },
        {
            title: 'RoPA',
            dataIndex: 'roPaList',
            key: 'roPaList',
            render: (list) => (
                <ul className="pl-1">
                    {list.map((item) => (
                        <li key={item.activityId}>{item.activityName}</li>
                    ))}
                    {list.length === 0 && <li className="list-none">-</li>}
                </ul>
            ),
            width: '40%',
        },
        {
            title: t('Department'),
            dataIndex: 'departmentEn',
            key: 'departmentEn',
            render: (departmentEn, record) => (
                <div>
                    {i18n.language === 'en'
                        ? departmentEn
                        : record.departmentTh}
                </div>
            ),
        },
    ];

    const paginationProps = {
        current: parseInt(pagevalue.p),
        // pageSize: 10,
        total: parseInt(pagevalue.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination) => {
        const id = params.get('id');
        const ids = getAllIdsFormCategory(id);
        const departmentId =
            allValues?.department === 'all' ? '' : allValues?.department;
        const payload = {
            ...ids,
            departmentId,
            p: pagination.current,
            ps: pagination.pageSize,
        };
        delete payload.total;
        getDataFlowRopa(payload);
    };

    return (
        <div className="font-semibold bg-white">
            {t('Related Data flow and RoPA', { count: pagevalue.total })}
            <Form
                layout="vertical"
                form={form}
                className="pt-4 grid grid-cols-2 gap-2"
                onValuesChange={onValuesChange}
                initialValues={{
                    department: 'all',
                }}
            >
                <FormItem label={t('Department')} name="department">
                    <Select size="large" options={department} />
                </FormItem>
            </Form>
            <Table
                className="inbox_table"
                rowKey={(record) => record.businessProcessId}
                loading={loadingDetail}
                dataSource={dataflowRopa}
                columns={columns_dataflow}
                pagination={paginationProps}
                onChange={onPageChange}
            />
        </div>
    );
}
